document.addEventListener("DOMContentLoaded", function() {
  function getRandomTime(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function startCountdown(duration) {
    let timer = duration, hours, minutes, seconds;
    const hoursSpan = document.getElementById('hours');
    const minutesSpan = document.getElementById('minutes');
    const secondsSpan = document.getElementById('seconds');

    setInterval(function() {
      const newHours = parseInt(timer / 3600, 10);
      const newMinutes = parseInt((timer % 3600) / 60, 10);
      const newSeconds = parseInt(timer % 60, 10);

      if (parseInt(hoursSpan.textContent, 10) !== newHours) {
        hoursSpan.textContent = newHours < 10 ? "0" + newHours : newHours;
        hoursSpan.parentElement.classList.add('flip');
        setTimeout(() => hoursSpan.parentElement.classList.remove('flip'), 600);
      }

      if (parseInt(minutesSpan.textContent, 10) !== newMinutes) {
        minutesSpan.textContent = newMinutes < 10 ? "0" + newMinutes : newMinutes;
        minutesSpan.parentElement.classList.add('flip');
        setTimeout(() => minutesSpan.parentElement.classList.remove('flip'), 600);
      }

      if (parseInt(secondsSpan.textContent, 10) !== newSeconds) {
        secondsSpan.textContent = newSeconds < 10 ? "0" + newSeconds : newSeconds;
        secondsSpan.parentElement.classList.add('flip');
        setTimeout(() => secondsSpan.parentElement.classList.remove('flip'), 600);
      }

      if (--timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  function initCountdown() {
    let randomMinutes = getRandomTime(8, 19) * 60; // Random time between 8 and 19 minutes
    let randomSeconds = getRandomTime(0, 59); // Random time between 0 and 59 seconds
    let totalRandomTime = randomMinutes + randomSeconds; // Combine random minutes and seconds
    startCountdown(totalRandomTime);
  }

  // Initialize countdown immediately after the container is loaded
  const countdownContainer = document.querySelector('.countdown-container');
  if (countdownContainer) {
    initCountdown();
  }
});